define('controllers/modules/noclient/noclient',[
    // parent
    'src/controller/controller',
    // services
    'services/user',
    // collections
    'collections/member/supervisors',
    // views
    'views/modules/noclient/noclient'
], function(
    // parent
    Controller,
    // services
    User,
    // collection
    Supervisors,
    // views
    VNoClient
) {

    var NoClientCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*noclient': 'index',
        },

        ////////////
        // routes //
        ////////////

        index: function(groupId) {
            var noClientView = new VNoClient();
            var layout = this.getLayout();

            this.when(
                layout.setGroupId(groupId),
                layout.getUnreadConversations(),
                User.fetch(),
                Supervisors.fetch()
            ).then(function() {
                this.getLayout().getContent().setView(noClientView, true);
            });
        },

        onBack: function() {
            this.trigger('back');
        },

    });

    return NoClientCtrl;
});

